export default __webpack_public_path__ + "static/media/Tutorial-Step-2.4.26938a9d.jpg";